import { FC } from 'react';

import AdminUsers from '../admin/AdminUsers';
import Payment from '../settings/Payment';
import GroupPage, { GroupSection } from './GroupPage';

type SettingsPageProps = {
  section: string | null;
  /** Point the URL at one of this page's sections. */
  onSectionChange: (section: string) => void;
  currentUsername: string | null;
  isAdmin: boolean;
  onExit: () => void;
  onUnauthorized: () => void;
};

/** How the till takes payment, and (for an admin) who has an account. */
const SettingsPage: FC<SettingsPageProps> = ({ section, onSectionChange, currentUsername, isAdmin, onExit, onUnauthorized }) => {
  const jumps = isAdmin
    ? [
        { id: 'payment', label: 'Payment' },
        { id: 'users', label: 'Users' },
      ]
    : [{ id: 'payment', label: 'Payment' }];
  const current = jumps.some((jump) => jump.id === section) ? section! : 'payment';

  return (
    <GroupPage
      className="settingsPage"
      title="Settings"
      subtitle={isAdmin ? 'Payment details, and the accounts on this install.' : 'Where customer payments go.'}
      jumps={jumps}
      hashPrefix="settings"
      activeHash={'#settings-' + current}
      scrollTo={section}
      onSectionNavigate={onSectionChange}
      onExit={onExit}
    >
      <GroupSection id="payment" hashPrefix="settings" label="Payment">
        <Payment onUnauthorized={onUnauthorized} />
      </GroupSection>
      {isAdmin && (
        <GroupSection id="users" hashPrefix="settings" label="Users">
          <AdminUsers currentUsername={currentUsername} onUnauthorized={onUnauthorized} />
        </GroupSection>
      )}
    </GroupPage>
  );
};

export default SettingsPage;
